import React, { PureComponent } from 'react';
import getLocale from './locale.js';
import URLInput from './URLInput';

class ContentSharing extends PureComponent {
  constructor(props) {
    super();
    this.locale = getLocale({ typeName: props.typeName });
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  renderOverview() {
    const localeKey = this.props.public ? 'public' : 'private';
    return (
      <div>
        <div className="c-brand-gray-darker">
          {this.props.public
            ? t('share_settings.shared.description')
            : this.locale.options[localeKey]}
        </div>
        {this.props.public && (
          <>
            <div className="mt-16 c-brand-gray-darker">
              {this.locale.options[localeKey]}
            </div>
            <URLInput className="mt-8" value={this.props.shareUrl} />
          </>
        )}
      </div>
    );
  }

  handleOptionChange(e) {
    const value = JSON.parse(e.target.value);
    if (this.props.public !== value) {
      this.props.onOptionChange(value);
    }
  }

  render() {
    const { locale } = this;
    const Option = props => (
      <RadioButtonLabel
        onChange={this.handleOptionChange}
        checked={this.props.public === props.value}
        {...props}
      />
    );

    if (!this.props.editing) {
      return this.renderOverview();
    }

    return (
      <div>
        <Option value={false} name="private" label={locale.options.private} />
        <Option
          value={true}
          name="public"
          label={t('share_settings.shared.description')}
        />

        {this.props.public && (
          <>
            <div className="ml-20 mt-16 c-brand-gray-darker">
              {locale.options.public}
            </div>
            <div className="ml-20 mt-8">
              <URLInput value={this.props.shareUrl} />
            </div>
          </>
        )}
        {this.props.editing && (
          <div className="d-f jc-e ai-c mt-16">
            <button
              type="button"
              className="ml-16 NewButton NewButton--blue NewButton--wide NewButton--center"
              onClick={this.props.toggleEditing}
              children="Done"
            />
          </div>
        )}
      </div>
    );
  }
}

const RadioButtonLabel = ({ value, name, label, checked, onChange }) => (
  <label className="d-f" htmlFor={`${name}.${value}`}>
    <input
      className="f-sh-0"
      checked={checked}
      id={`${name}.${value}`}
      name={name}
      onChange={onChange}
      type="radio"
      value={value}
    />
    <span className="ml-8 c-brand-gray-darker">{label}</span>
  </label>
);

export default ContentSharing;
